module.exports = __webpack_public_path__ + "static/img/teambannerb.3e9ea16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teambannerb.jpg
// module id = fhrs
// module chunks = 1